import styled from 'styled-components'

const Label = (props) => {
  const { text } = props

  return <PageView>{text}</PageView>
}

const PageView = styled.div`
  width: 100%;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: ${(p) => p.theme.color_level.grey.high};
  padding-bottom: 12px;
`

export default Label
